(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tebr-notes"] && !Shopify.designMode) return;
  try {
    
  /**
   * Meter animation: the bars sweep in and the percentages count up when they
   * scroll into view. Progressive enhancement — the server renders the final
   * widths and numbers, and they are only zeroed AFTER we know the observer
   * exists, so no JavaScript means full, correct meters.
   */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const fills = document.querySelectorAll('.meter-fill');
    if (!fills.length) return;

    fills.forEach(function (f) {
      if (f.dataset.armed) return;
      f.dataset.armed = '1';
      f.dataset.final = f.style.width;
      f.style.transition = 'none';
      f.style.width = '0%';
      const num = f.closest('.meter') && f.closest('.meter').querySelector('.meter-num');
      if (num) num.textContent = '0%';
    });

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const f = entry.target;
        io.unobserve(f);

        requestAnimationFrame(function () {
          f.style.transition = 'width 1.1s cubic-bezier(0.16, 1, 0.3, 1)';
          f.style.width = f.dataset.final;
        });

        const num = f.closest('.meter') && f.closest('.meter').querySelector('.meter-num');
        if (num) {
          const target = parseInt(num.dataset.pct || '0', 10);
          let t0 = null;
          const step = function (ts) {
            if (!t0) t0 = ts;
            const p = Math.min(1, (ts - t0) / 1100);
            const eased = 1 - Math.pow(1 - p, 3);
            num.textContent = Math.round(target * eased) + '%';
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.4 });

    fills.forEach(function (f) { io.observe(f); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tebr-pdp"] && !Shopify.designMode) return;
  try {
    
  class TebrGallery {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-pdx-track]');
      this.slides = Array.from(root.querySelectorAll('[data-pdx-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-pdx-thumb]'));
      this.count = root.querySelector('[data-pdx-count]');
      this.prev = root.querySelector('[data-pdx-prev]');
      this.next = root.querySelector('[data-pdx-next]');
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.bind();
      this.sync();
    }

    bind() {
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));

      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.go(i)));

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      });
    }

    go(i) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.slides[clamped].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    sync() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      this.slides.forEach((slide, i) => {
        const centre = slide.offsetLeft - this.track.offsetLeft + slide.clientWidth / 2;
        const dist = Math.abs(centre - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      this.index = best;

      this.thumbs.forEach((thumb, i) => {
        if (i === best) {
          thumb.setAttribute('aria-current', 'true');
          if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.count) this.count.textContent = (best + 1) + ' / ' + this.slides.length;
      if (this.prev) this.prev.disabled = best === 0;
      if (this.next) this.next.disabled = best === this.slides.length - 1;
    }
  }

  function initTebrGalleries() {
    document.querySelectorAll('[data-pdx]').forEach((el) => {
      if (el.dataset.pdxReady) return;
      el.dataset.pdxReady = 'true';
      new TebrGallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTebrGalleries);
  } else {
    initTebrGalleries();
  }
  document.addEventListener('shopify:section:load', initTebrGalleries);

  /**
   * Entrance choreography. gsap.from means the resting state is plain CSS —
   * if the CDN never loads, the page is simply static, never blank. GSAP is
   * deferred, so if it is not ready yet, retry once on window load.
   */
  function tebrPdpIntro() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.gsap) {
      window.addEventListener('load', tebrPdpIntro, { once: true });
      return;
    }
    const pd = document.querySelector('.pd');
    if (!pd || pd.dataset.introDone) return;
    pd.dataset.introDone = '1';

    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    tl.from('.pdx__frame', { y: 30, opacity: 0, scale: 0.985, duration: 0.9, clearProps: 'opacity,transform' })
      .from('.pd__p > *', { y: 22, opacity: 0, duration: 0.7, stagger: 0.07, clearProps: 'opacity,transform' }, '-=0.55')
      .from('.pdx__thumbs', { opacity: 0, duration: 0.5, clearProps: 'opacity' }, '-=0.4');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tebrPdpIntro);
  } else {
    tebrPdpIntro();
  }

  /**
   * PDP size buttons. One tap updates: the pressed state, the hidden variant
   * id in BOTH forms (buy box and sticky bar), the price row (current, was,
   * discount), the chip on the photo and the URL's ?variant= so shares land
   * on the chosen size. The main price pulses so the change is impossible to
   * miss. The qty module in tebr.js repaints the stepper after this runs.
   */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pd__sizebtn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    document.querySelectorAll('.pd__sizebtn').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    const vid = btn.getAttribute('data-vid');
    document.querySelectorAll('.pd__buy [name="id"], .bar .js-add [name="id"]').forEach(function (input) {
      input.value = vid;
    });

    const price = btn.getAttribute('data-price');
    const was = btn.getAttribute('data-was');
    const off = btn.getAttribute('data-off');

    const cur = document.querySelector('.pd__price-current');
    if (cur && price) {
      cur.textContent = price;
      cur.classList.remove('pulse');
      void cur.offsetWidth; /* restart the animation on every tap */
      cur.classList.add('pulse');
    }
    const wasEl = document.querySelector('.pd__price-was');
    if (wasEl) {
      if (was) { wasEl.textContent = was; wasEl.style.display = ''; }
      else { wasEl.style.display = 'none'; }
    }
    document.querySelectorAll('.pd__price-off, .pdx__off').forEach(function (offEl) {
      if (off && off !== '0') { offEl.textContent = '−' + off + '%'; offEl.style.display = ''; }
      else { offEl.style.display = 'none'; }
    });
    const barPrice = document.querySelector('.bar__price');
    if (barPrice && price) barPrice.textContent = price;

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', vid);
      window.history.replaceState({}, '', url);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tebr-product-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * Any "#reviews" link (the star line under the PDP title, card ratings)
   * lands on the band and, when there is no review yet, opens Judge.me's
   * write-a-review form so one tap reaches an open form.
   */
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href$="#reviews"]');
    if (!a) return;
    const band = document.getElementById('reviews');
    if (!band || band.querySelector('.jdgm-rev')) return;
    const link = band.querySelector('.jdgm-write-rev-link');
    if (link && !link.classList.contains('jdgm-write-rev-link--active')) {
      setTimeout(function () { link.click(); }, 350);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
